import React from 'react'
import {Trans} from '@lingui/macro'
import {useDispatch, useSelector} from 'react-redux'
import {ButtonLink} from 'components/UI/ButtonLink/ButtonLink'
import {getColor} from 'components/utils'
import {Alert} from 'components/UI/Alert/Alert'
import {MinusSmIcon, LockClosedIcon} from '@heroicons/react/outline'
import {
    dPosConfigurationSetDetailItemAC
} from 'model/dashboardPosConfiguration/dPosConfigurationActionCreators'
import {
    DotsVerticalIcon,
} from '@heroicons/react/outline'
import {IdPosConfigurationState} from 'model/dashboardPosConfiguration/dPosConfigurationReducer'


// Type
export type typeTableHeader = {
    variant?: string
}


// Header data component
export const TableHeader: React.FC<typeTableHeader> = ({variant }) => {

    return(
        <>
            <th scope="col" className="px-4 py-3 text-left text-xs font-medium  uppercase tracking-wider">
                <Trans>Name</Trans>
            </th>
            <th scope="col" className="px-4 py-3 text-xs font-medium uppercase tracking-wider text-center">
                <Trans>Stores</Trans>
            </th>
            <th scope="col" className="px-4 py-3 text-xs font-medium uppercase tracking-wider text-center">
                <Trans>POS</Trans>
            </th>
            <th scope="col" className="px-4 py-3 text-xs font-medium uppercase tracking-wider text-center">
                <Trans>Categories / Products</Trans>
            </th>
            <th scope="col" className="w-1">
            </th>
        </>
    )
}


// Type
export type typeAction = {
    title: JSX.Element,
    disableSwitcher?: boolean,
    action: (id: string) => void,
}

export type typeTableBody = {
    variant?: string
    setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>
    rowsActions: typeAction[]
}


// Body data component
export const TableBody: React.FC<typeTableBody> = ({variant, setOpenPopupDetails, rowsActions}) => {

    const color = getColor(variant)

    const dispatch = useDispatch()

    const tableData = useSelector((state: {dPosConfiguration: IdPosConfigurationState}) => state.dPosConfiguration.data)

    const onCellClickHandler = ( e: React.MouseEvent<HTMLTableDataCellElement, MouseEvent>, id: string) => {
        dispatch(dPosConfigurationSetDetailItemAC(id))
        setOpenPopupDetails(true)
    }

    let component

    if (tableData.length) {

        component = tableData.map((item, index) => {

            return(
                <tr key={item.id} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-${color}-50`}>

                    <td className={`px-4 py-3  text-sm font-medium text-gray-900 cursor-pointer`}  onClick={(e) => onCellClickHandler(e, item.id)}>
                        {item.id === 'default'
                            ? <><div className="flex gap-x-1 text-gray-400"><Trans>Default configuration</Trans><LockClosedIcon className="h-5 w-5 text-gray-400"/></div></>
                            : <div className={'break-all'}>{ item.name }</div>
                        }
                    </td>

                    <td className={`px-4 py-3 whitespace-nowrap text-sm text-gray-900 cursor-pointer`}  onClick={(e) => onCellClickHandler(e, item.id)}>
                        <div className="flex justify-center">
                            {item.storeIds && item.storeIds.length
                                ? <>
                                    {item.storeIds.length}
                                </>
                                : <MinusSmIcon className="h-4 w-4 text-gray-400"/>
                            }
                        </div>
                    </td>

                    <td className={`px-4 py-3 whitespace-nowrap text-sm text-gray-900 cursor-pointer`}  onClick={(e) => onCellClickHandler(e, item.id)}>
                        <div className="flex justify-center">
                            {item.posIds && item.posIds.length
                                ? <>
                                    {item.posIds.length}
                                </>
                                : <MinusSmIcon className="h-4 w-4 text-gray-400"/>
                            }
                        </div>
                    </td>

                    <td className={`px-4 py-3 whitespace-nowrap text-sm text-gray-900 cursor-pointer`}  onClick={(e) => onCellClickHandler(e, item.id)}>
                        <div className="flex justify-center">
                            {item.posCategories && item.posCategories.length
                                ? <>
                                    <span>{item.posCategories.length} / {item.posCategories.reduce((sum: number, categoryItem: any) => sum + categoryItem.productIds.length, 0)}</span>
                                </>
                                : <MinusSmIcon className="h-4 w-4 text-gray-400"/>
                            }
                        </div>
                    </td>

                    <td className="whitespace-nowrap text-sm text-gray-500 pr-2">
                        {item.id !== 'default'
                            ? <div className="relative flex">
                                <div className="row-action-block">
                                    <DotsVerticalIcon className="row-action-list-open-button"/>
                                    <div className="row-action-list">
                                        <div className="flex gap-x-4">
                                            {rowsActions.map((actionItem, ActionIndex) => {
                                                return <ButtonLink key={ActionIndex} type={"button"} label={actionItem.title} onClick={() => actionItem.action(item.id)}/>
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : null
                        }
                    </td>

                </tr>
            )
        })
    } else {
        component = <tr>
            <td className="p-2" colSpan={4}>
                <Alert className="w-full" type={"info"} title={<Trans>The POS configuration list is empty. Click on the Add button to add a new configuration.</Trans>}/>
            </td>
        </tr>
    }

    return(
        <>
            {component}
        </>
    )
}
